import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { useDispatch, useSelector } from "react-redux";
import {
  getTotalbetCache,
  newLotteryInvoice,
  SocketResultHuay,
  getResultBuyHuay,
  resetResultHuay,
  disconnectHuayYak,
} from "../../features/lotteryInvoice";
import { changeTypeToName } from "../../helper/changeBankIdtoName";
import numToFixed from "../../helper/numToFixed";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../LoadingPage";

const ButtonPrice = (props) => (
  <button
    value={props.price}
    onClick={props.onCLick}
    className=" p-1 w-full rounded border border-gray-500 text-gray-500"
    style={{ fontFamily: "Menlo" }}
  >
    {props.price}฿
  </button>
);

const ModalGetBetCache = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const invoice = useSelector((state) => state.invoice.totalbetcache);
  const holdnumber = useSelector((state) => state.invoice.holdNumber);
  const credit = useSelector((state) => state.credit.credit);
  const memberSetting = useSelector((state) => state.invoice.memberSetting);
  const resultHuay = useSelector((state) => state.invoice.resultBuy);
  const huayType = [
    "bon_6",
    "bon_5",
    "bon_4",
    "bon_3",
    "tode_3",
    "na_3",
    "lang_3",
    "bon_2",
    "lang_2",
    "bon_1",
    "lang_1",
  ];

  const [invoiceRemark, setInvoiceRemark] = useState("");
  const [allAmount, setAllAmount] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [open, setOpen] = useState(false);
  const [Tickets, setTickets] = useState([]);
  const [index, setIndex] = useState(0);
  const [lotteryName, setLotteryName] = useState(
    localStorage.getItem("lotteryName")
  );
  const [Round, setRound] = useState(localStorage.getItem("Round"));
  const [CloseButton, setCloseButton] = useState(false);
  const [Count, setCount] = useState(0);
  const [room, setRoom] = useState(false);

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const handleChange = async () => {
    setOpen(true);
    await dispatch(getTotalbetCache());
    await setTickets(
      JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId")))
    );
  };

  const closeModal = () => {
    setOpen(false);
    setAllAmount("");
    setIndex(0);
    setTickets([]);
  };

  const onChange = async (e) => {
    if (e.target.value == "0") {
      e.target.value = "1";
    }
    let tickets = [...Tickets];
    let indexx = tickets.findIndex((data) => {
      return (
        data.lotteryType == e.target.name && data.lotteryNumber == e.target.id
      );
    });
    let ticket = { ...tickets[indexx], betAmount: e.target.value };

    const setting = memberSetting.data.find(
      (data) => ticket.lotteryType == data.betType
    );
    const checkholdnumber = holdnumber.find(
      (data) =>
        data.betNumber == ticket.lotteryNumber &&
        data.betType == ticket.lotteryType
    );

    if (checkholdnumber) {
      if (
        Number(ticket.betAmount) >
          checkholdnumber.betLimit - checkholdnumber.totalBet ||
        Number(ticket.betAmount) > setting.maximumBetPerTicket
      ) {
        ticket.betAmount = checkholdnumber.betLimit - checkholdnumber.totalBet;
        if (Number(ticket.betAmount) > setting.maximumBetPerTicket) {
          ticket.betAmount = setting.maximumBetPerTicket;
        }
      }

      if (checkholdnumber.betLimit - checkholdnumber.totalBet > 0) {
        ticket.rewardRate = checkholdnumber.price;
        ticket.rewardAmount = checkholdnumber.price * ticket.betAmount;
        if (Number(ticket.betAmount) > setting.maximumBetPerTicket) {
          ticket.rewardRate = setting.maximumBetPerTicket;
          ticket.rewardAmount = setting.maximumBetPerTicket * ticket.betAmount;
        }
      } else {
        ticket.rewardRate = 0;
        ticket.rewardAmount = 0;
      }
    } else {
      let num;
      if (ticket.lotteryType == "tode_3") {
        num = ticket.lotteryNumber.split("").sort().join("");
      } else {
        num = ticket.lotteryNumber;
      }
      const cache = invoice[ticket.lotteryType][num];

      if (ticket.betAmount > setting.maximumBetPerTicket) {
        ticket.betAmount = setting.maximumBetPerTicket;
      }
      const rewarRate = setting.baseStepPrices.find((data) => {
        return (
          Number(cache[data.price]) + Number(ticket.betAmount) <= data.betLimit
        );
      });

      ticket.rewardRate = rewarRate?.price || 0;
      ticket.rewardAmount = rewarRate?.price * ticket.betAmount || 0;
    }
    if (e.target.value.match(/^[0-9]*$/)) {
      tickets[indexx] = ticket;
      await setTickets(tickets);
    }
  };

  const onChangeAll = (e) => {
    if (e.target.value == "0") {
      e.target.value = "1";
    }
    if (e.target.value.match(/^[0-9]*$/)) {
      let tickets = [...Tickets];

      tickets.map((ticket) => {
        const checkholdnumber = holdnumber.find(
          (data) =>
            data.betNumber == ticket.lotteryNumber &&
            data.betType == ticket.lotteryType
        );
        const setting = memberSetting.data.find(
          (data) => ticket.lotteryType == data.betType
        );
        ticket.betAmount = e.target.value;

        if (checkholdnumber) {
          if (
            Number(ticket.betAmount) >
              checkholdnumber.betLimit - checkholdnumber.totalBet ||
            Number(ticket.betAmount) > setting.maximumBetPerTicket
          ) {
            ticket.betAmount =
              checkholdnumber.betLimit - checkholdnumber.totalBet;
            if (Number(ticket.betAmount) > setting.maximumBetPerTicket) {
              ticket.betAmount = setting.maximumBetPerTicket;
            }
          }

          if (checkholdnumber.betLimit - checkholdnumber.totalBet > 0) {
            ticket.rewardRate = checkholdnumber.price;
            ticket.rewardAmount = checkholdnumber.price * ticket.betAmount;
            if (Number(ticket.betAmount) > setting.maximumBetPerTicket) {
              ticket.rewardRate = setting.maximumBetPerTicket;
              ticket.rewardAmount =
                setting.maximumBetPerTicket * ticket.betAmount;
            }
          } else {
            ticket.rewardRate = 0;
            ticket.rewardAmount = 0;
          }
        } else {
          let num;
          if (ticket.lotteryType == "tode_3") {
            num = ticket.lotteryNumber.split("").sort().join("");
          } else {
            num = ticket.lotteryNumber;
          }
          const cache = invoice[ticket.lotteryType][num];
          if (ticket.betAmount > setting.maximumBetPerTicket) {
            ticket.betAmount = setting.maximumBetPerTicket;
          }
          const rewarRate = setting.baseStepPrices.find(
            (data) =>
              Number(cache[data.price]) + Number(ticket.betAmount) <=
              data.betLimit
          );
          ticket.rewardRate = rewarRate?.price || 0;
          ticket.rewardAmount = rewarRate?.price * ticket.betAmount || 0;
        }
        setTickets(tickets);
        setAllAmount(e.target.value);
      });
    }
  };

  const newInvoice = async () => {
    setCloseButton(true);
    const res = await newLotteryInvoice(Tickets, totalAmount, invoiceRemark);
    if (res.code == "999999") {
      setCount((prev) => prev + 1);
    } else {
      alert("เกิดปัญหาในการส่งโพย กรุณาลองใหม่อีกครั้ง");
      setOpen(false);
      setIndex(0);
    }
    setCloseButton(false);
  };

  const checkInvalid = () => {
    const invalid = [];
    Tickets.map((data) => {
      if (
        data.betAmount <= 0 ||
        data.betAmount <= "" ||
        data.rewardAmount == 0 ||
        data.rewardRate == 0
      ) {
        invalid.push(data.lotteryNumber);
      }
    });

    if (invalid.length) {
      return alert("มีเลขที่ไม่ใส่ราคาหรืออัตราจ่ายเป็น 0");
    }

    if (Number(credit) - Number(totalAmount) < 0) {
      return alert("เครดิตมีน้อยกว่ายอดแทงทั้งหมด");
    }

    return setIndex(1);
  };

  const changeColorType = (Type, rewardRate) => {
    let color;
    if (Type == "bon_6") {
      color = "text-purple-500";
    } else if (Type == "bon_5") {
      color = "text-sky-500";
    } else if (Type == "bon_4") {
      color = "text-green-500";
    } else if (
      Type == "bon_3" ||
      Type == "tode_3" ||
      Type == "na_3" ||
      Type == "lang_3"
    ) {
      color = "text-yellow-500";
    } else if (Type == "bon_2" || Type == "lang_2") {
      color = "text-orange-500";
    } else if (Type == "bon_1" || Type == "lang_1") {
      color = "text-red-500";
    }
    return color;
  };

  useEffect(() => {
    let TotalAmount = 0;
    Tickets.map((data) => {
      TotalAmount += parseInt(data.betAmount);
    });
    setTotalAmount(TotalAmount);

    if(!room) {
      disconnectHuayYak();
      SocketResultHuay();
      dispatch(getResultBuyHuay());
      setRoom(true)
    }

    const countdown = async () => {
      if (Count > 0 && Count <= 7) {
        if (resultHuay) {
          if (resultHuay.code == "0") {
            props.deleteListTickets("checked");
            setAllAmount("");
            setIndex(2);
            setCount(0);
          } else {
            alert(resultHuay.message);
          }
          setCloseButton(false);
        } else {
          await sleep(1000);
          await setCount((prev) => prev + 1);
        }
      }
      if (Count > 7) {
        alert("การส่งโพยขัดข้อง กรุณารอสักครู่แล้วเชคที่หน้าดูโพยนะคะ");
        setOpen(false);
        setIndex(0);
        setCount(0);
        dispatch(resetResultHuay());
        setCloseButton(false);
      }
    };
    countdown();

  }, [Tickets, Count]);

  return (
    <React.Fragment>
      <button
        className="text-base h-full w-full text-[#f8eede] bg-gradient-to-t from-[#b3853e] to-[#b3853e] rounded px-5 py-2 font-bold"
        onClick={handleChange}
      >
        <span className="mr-1">{<ShoppingCartRoundedIcon />}</span>
        <span className="mr-1">ใส่ราคา</span>
        <span className="mr-1">
          {
            JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId")))
              ?.length
          }
        </span>
        <span className="mr-1">รายการ</span>
      </button>
      <Dialog
        id={props.refCode}
        fullWidth={true}
        fullScreen={true}
        maxWidth="xl"
        open={open}
        onClose={closeModal}
        aria-labelledby="max-width-dialog-title"
      >
        <div className="py-2 px-2 flex justify-between border-b text-gray-600">
          {index == "0" ? (
            <>
              <div onClick={closeModal}>{<ArrowBackRoundedIcon />}</div>
              <div className="text-base pl-14 font-bold">
                ใส่ราคา <span className="">{Tickets.length}</span> รายการ
              </div>
              <div>
                <button
                  className="py-1 px-1.5 text-xs rounded border border-gray-600"
                  onClick={() => {
                    props.deleteListTickets();
                    setOpen(false);
                    setAllAmount("");
                  }}
                >
                  {<DeleteRoundedIcon />} ลบทั้งหมด
                </button>
              </div>
            </>
          ) : index == "1" ? (
            <>
              <div onClick={() => setIndex(0)}>{<ArrowBackRoundedIcon />}</div>

              <div className="text-base font-bold ml-x15">
                ตรวจสอบก่อนยืนยันการส่งโพย
              </div>
              <div></div>
            </>
          ) : (
            <>
              <div onClick={closeModal}>{<ArrowBackRoundedIcon />}</div>

              <div className="text-base font-bold ml-x15">
                ยืนยันการส่งโพยเรียบร้อย
              </div>
              <div></div>
            </>
          )}
        </div>

        {index == "0" ? (
          <>
            <div className="overflow-y-auto h-3/4 pb-32 text-sm px-1">
              {huayType.map((type) =>
                Tickets?.filter((data) => data.lotteryType == type).map(
                  (number, i) => (
                    <>
                      {i == 0 ? (
                        <div className="grid grid-cols-12 text-center text-sm text-gray-600">
                          <p className="col-span-3 font-bold">
                            {changeTypeToName(type)}
                          </p>
                          <p className="col-span-3">ราคา</p>
                          <p className="col-span-2">บาทละ</p>
                          <p className="col-span-3">เรทชนะ</p>
                          <div className="col-span-1"></div>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div
                        className={`grid grid-cols-12 gap-0.5 text-center text-base py-1 mt-1 bg-defaultTapInputCredit rounded`}
                      >
                        <p
                          className={`col-span-3 pt-0.5 mx-3 ${changeColorType(
                            number.lotteryType,
                            number.rewardRate
                          )} rounded-full font-bold`}
                        >
                          {number.lotteryNumber}
                        </p>

                        <input
                          type="number"
                          className="col-span-3 text-center font-bold border border-gray-300 text-gray-500 rounded px-1 outline-none focus:ring-1 focus:border-0 focus:ring-gray-200"
                          placeholder="ระบุเงิน"
                          style={{ fontSize: "16px" }}
                          value={number.betAmount}
                          name={number.lotteryType}
                          id={number.lotteryNumber}
                          onChange={onChange}
                        />
                        <p
                          className={`col-span-2 font-bold text-sm pt-1 text-defaultButtonType2`}
                        >
                          {number.rewardRate}
                        </p>
                        <div className="col-span-3">
                          <p className="text-center bg-white text-sm py-0.5 text-defaultStatusWin2 font-bold rounded px-0 outline-none focus:ring-1 focus:border-0 focus:ring-gray-200">
                            {numToFixed(number.rewardAmount)}
                          </p>
                        </div>

                        <button
                          onClick={() => {
                            props.deleteTicket(number);
                            setTickets(
                              Tickets.filter(
                                (ticket) =>
                                  ticket.lotteryNumber !=
                                    number.lotteryNumber ||
                                  ticket.lotteryType != number.lotteryType
                              )
                            );
                          }}
                          className="col-span-1 text-defaultStatusLost2"
                        >
                          {<DeleteRoundedIcon />}
                        </button>
                      </div>
                    </>
                  )
                )
              )}
            </div>

            <div className="absolute inset-x-0 bottom-0 border-t">
              <div className="bg-green-500 grid grid-cols-3 gap-1 px-1 text-base py-1 text-center font-bold text-white-500">
                <div className="py-4">บันทึกโพย :</div>
                <textarea
                  className="col-span-2 border rounded w-full py-1 px-5 focus:outline-none focus:ring-2 focus:ring-defaultColor"
                  rows="2"
                  cols="50"
                  onChange={(e) => setInvoiceRemark(e.target.value)}
                  value={invoiceRemark}
                  placeholder=""
                ></textarea>
              </div>
              <div className="pt-0 bg-white">
                <div className="grid grid-cols-2 gap-1 px-1 text-base py-1 text-center font-bold text-gray-500">
                  <div className="bg-defaultTapInputCredit rounded py-2">
                    <p>ยอดแทงทั้งหมด: </p>
                    <p className="">
                      {totalAmount ? totalAmount : 0}
                      <span style={{ fontFamily: "Menlo" }}>฿</span>
                    </p>
                  </div>
                  <div className="bg-defaultTapInputCredit rounded py-2">
                    <p>ยอดเงินคงเหลือ:</p>
                    <p>
                      {numToFixed(credit - (totalAmount ? totalAmount : 0))}
                      <span style={{ fontFamily: "Menlo" }}>฿</span>
                    </p>
                  </div>
                </div>
                <div className="px-1 grid grid-cols-7 gap-0.5 text-base pb-1 border-b border-gray-200">
                  <input
                    type="number"
                    className="h-auto col-span-2 text-center py-2 px-1 border border-gray-500 w-full rounded outline-none"
                    style={{ fontSize: "16px" }}
                    placeholder="กดจำนวนเงิน"
                    onChange={(e) => onChangeAll(e)}
                    value={allAmount}
                  />
                  <ButtonPrice price="5" onCLick={onChangeAll} />
                  <ButtonPrice price="10" onCLick={onChangeAll} />
                  <ButtonPrice price="20" onCLick={onChangeAll} />
                  <ButtonPrice price="50" onCLick={onChangeAll} />
                  <ButtonPrice price="100" onCLick={onChangeAll} />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-2 px-1 bg-white pt-1 pb-1">
                <button
                  className="py-2 rounded text-[#f8eede] font-bold bg-gradient-to-t from-[#b3853e] to-[#b3853e]"
                  onClick={() => {
                    checkInvalid();
                  }}
                >
                  กดส่งโพย
                </button>
              </div>
            </div>
          </>
        ) : index == "1" ? (
          <>
            <div className="m-1 rounded bg-defaultTapInputCredit">
              <p className="text-base pt-2 text-center w-auto text-defaultHeadNameHuay">
                {lotteryName} {Round ? `รอบที่ ${Round}` : ``} งวด{" "}
                {new Date(
                  localStorage.getItem("closeRoundDatetime")
                ).toLocaleDateString("th-TH")}
              </p>
              <p className="text-base text-center text-red-600 py-2">
                {<WarningAmberRoundedIcon />}{" "}
                กรุณาตรวจสอบข้อมูลทั้งหมดก่อนกดยืนยัน
              </p>
            </div>
            <div className="border-dashed border-t border-r border-l border-gray-600 mx-1  text-base font-bold pt-2.5 px-1">
              <div className="text-center border-b border-gray-600 pb-2.5 text-gray-600">
                <span>ยอดแทงทั้งหมด </span>
                <span className="text-defaultStatusWin2">
                  {numToFixed(totalAmount)}
                  <span style={{ fontFamily: "Menlo" }}>฿</span>
                </span>
                <span> จำนวน </span>
                <span className="text-defaultStatusWin2">{Tickets.length}</span>
                <span> รายการ</span>
                <p className="text-center font-bold">
                </p>
              </div>
            </div>
            <div className="overflow-y-auto h-4/5 mt-1 xs:h-2/3 pb-16 mx-1">
              <div className="border-dashed border-b border-r border-l border-gray-600 pb-2">
                {huayType.map((type) =>
                  Tickets?.filter((data) => data.lotteryType == type).map(
                    (number, i) => (
                      <>
                        {i == 0 ? (
                          <div className="grid grid-cols-12 text-center py-1">
                            <p className="col-span-3 font-bold text-normal pt-0.5">
                              <div className="flex justify-between">
                                <span className="pl-2">#</span>
                                <span>{changeTypeToName(type)}</span>
                                <span></span>
                              </div>
                            </p>
                            <p className="col-span-3">ราคา</p>
                            <p className="col-span-2">บาทละ</p>
                            <p className="col-span-4">เรทชนะ</p>
                          </div>
                        ) : (
                          <></>
                        )}
                        <div
                          className={`grid grid-cols-12 gap-0.5 text-center text-base py-1 mt-1 bg-defaultTapInputCredit rounded mx-1`}
                        >
                          <div className="col-span-3">
                            <div className="flex justify-between">
                              <span className={`pt-0.5 pl-1 text-gray-500`}>
                                {i <= 8 ? "0" + (i + 1) : i + 1}.
                              </span>

                              <span
                                className={`pt-0.5 pr-3 ${changeColorType(
                                  number.lotteryType,
                                  number.rewardRate
                                )} font-bold`}
                              >
                                {number.lotteryNumber}
                              </span>
                              <span></span>
                            </div>
                          </div>
                          <p className="col-span-3 bg-white pt-0.5 text-center text-normal font-bold text-gray-500 rounded px-1 outline-none focus:ring-1 focus:border-0 focus:ring-gray-200">
                            {numToFixed(number.betAmount)}
                            <span style={{ fontFamily: "Menlo" }}>฿</span>
                          </p>
                          <p
                            className={`col-span-2 font-bold text-sm pt-1 text-defaultButtonType2`}
                          >
                            {number.rewardRate}
                          </p>
                          <div className="col-span-4">
                            <p className="text-center bg-white text-sm py-0.5 text-defaultStatusWin2 font-bold rounded mr-1 outline-none focus:ring-1 focus:border-0 focus:ring-gray-200">
                              {numToFixed(number.rewardAmount)}
                              <span style={{ fontFamily: "Menlo" }}>฿</span>
                            </p>
                          </div>
                        </div>
                      </>
                    )
                  )
                )}
              </div>
            </div>
            {/* </div> */}

            <div className="absolute inset-x-0 bottom-0 border-t">
              <div className="pt-0 bg-white">
                <div className="bg-green-500 grid grid-cols-2 gap-1 px-1 text-base py-1 text-center font-bold text-white-500">
                  <div>บันทึกโพย :</div>

                  <input
                    type="text"
                    required="required"
                    min={100}
                    className="border bg-gray-300 rounded w-full py-1 px-5 focus:outline-none focus:ring-2 focus:ring-defaultColor"
                    placeholder=""
                    value={invoiceRemark}
                    disabled
                  />
                </div>
                <div className="grid grid-cols-3 gap-2 font-bold p-1 text-center  bg-gradient-to-t from-[#b3853e] to-[#b3853e]">
                  <button
                    className="text-base h-full w-full text-defaultPlayHuayDeactive bg-gradient-to-t from-[#D1B000] to-[#FFD700]  rounded px-5 font-bold"
                    onClick={() => setIndex(0)}
                  >
                    แก้ไขราคา
                  </button>
                  <div className="col-span-2">
                    <button
                      className="text-base h-full w-full text-[#f8eede] rounded px-5 py-2 font-bold border-2 border-[#f8eede]"
                      onClick={() => newInvoice()}
                      disabled={CloseButton}
                    >
                      {CloseButton ? "รอสักครู่" : "ยืนยันการส่งโพย"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="m-1 rounded bg-defaultTapInputCredit">
              <p className="text-base pt-2 text-center w-auto text-sky-500">
                {lotteryName} {Round ? `รอบที่ ${Round}` : ``} งวด{" "}
                {new Date(
                  localStorage.getItem("closeRoundDatetime")
                ).toLocaleDateString("th-TH")}
              </p>
              <div className="text-base text-center text-green-600 pt-2">
                {<CheckCircleRoundedIcon />}
                <span> สั่งซื้อสำเร็จ Ref:{resultHuay?.data.refCode}</span>
              </div>
              <p className="text-center text-gray-500 text-sm pt-1 pb-2">
                ซื้อเมื่อเวลา:{" "}
                {new Date(resultHuay?.data.invoiceDatetime).toLocaleString(
                  "th-TH"
                )}
              </p>
            </div>

            <div className="border-dashed border-t border-r border-l border-gray-600 mx-1 text-base font-bold pt-2.5 px-1">
              <div className="text-center border-b border-gray-600 pb-2.5 text-gray-600">
                <span>ยอดแทงทั้งหมด </span>
                <span className="text-green-600">
                  {numToFixed(totalAmount)}
                  <span style={{ fontFamily: "Menlo" }}>฿</span>
                </span>
                <span> จำนวน </span>
                <span className="text-green-600">{Tickets.length}</span>
                <span> รายการ</span>
                <p className="text-center font-bold">
                </p>
              </div>
            </div>

            <div className="overflow-y-auto h-4/5 mt-1 xs:h-2/3 pb-16 mx-1">
              <div className="border-dashed border-b border-r border-l border-gray-600 pb-2">
                {huayType.map((type) =>
                  Tickets?.filter((data) => data.lotteryType == type).map(
                    (number, i) => (
                      <>
                        {i == 0 ? (
                          <div className="grid grid-cols-12 text-center py-1">
                            <p className="col-span-3 font-bold text-normal pt-0.5">
                              <div className="flex justify-between">
                                <span className="pl-2">#</span>
                                <span>{changeTypeToName(type)}</span>
                                <span></span>
                              </div>
                            </p>
                            <p className="col-span-3">ราคา</p>
                            <p className="col-span-2">บาทละ</p>
                            <p className="col-span-4">เรทชนะ</p>
                          </div>
                        ) : (
                          <></>
                        )}
                        <div
                          className={`grid grid-cols-12 gap-0.5 text-center text-base py-1 mt-1 bg-defaultTapInputCredit rounded mx-1`}
                        >
                          <div className="col-span-3">
                            <div className="flex justify-between">
                              <span className={`pt-0.5 pl-1 text-gray-500`}>
                                {i <= 8 ? "0" + (i + 1) : i + 1}.
                              </span>

                              <span
                                className={`pt-0.5 pr-3 ${changeColorType(
                                  number.lotteryType,
                                  number.rewardRate
                                )} font-bold`}
                              >
                                {number.lotteryNumber}
                              </span>
                              <span></span>
                            </div>
                          </div>
                          <p className="col-span-3 bg-white pt-0.5 text-center text-normal font-bold text-gray-500 rounded px-1 outline-none focus:ring-1 focus:border-0 focus:ring-gray-200">
                            {numToFixed(number.betAmount)}
                            <span style={{ fontFamily: "Menlo" }}>฿</span>
                          </p>
                          <p
                            className={`col-span-2 font-bold text-sm pt-1 text-defaultButtonType2`}
                          >
                            {number.rewardRate}
                          </p>
                          <div className="col-span-4">
                            <p className="text-center bg-white text-sm py-0.5 text-defaultStatusWin2 font-bold rounded mr-1 outline-none focus:ring-1 focus:border-0 focus:ring-gray-200">
                              {numToFixed(number.rewardAmount)}
                              <span style={{ fontFamily: "Menlo" }}>฿</span>
                            </p>
                          </div>
                        </div>
                      </>
                    )
                  )
                )}
              </div>
            </div>

            <div className="absolute inset-x-0 bottom-0 border-t">
              <div className="bg-green-500 grid grid-cols-2 gap-1 px-1 text-base py-1 text-center font-bold text-white-500">
                <div>บันทึกโพย :</div>

                <input
                  type="text"
                  required="required"
                  min={100}
                  className="border bg-gray-300 rounded w-full py-1 px-5 focus:outline-none focus:ring-2 focus:ring-defaultColor"
                  placeholder=""
                  value={invoiceRemark}
                  disabled
                />
              </div>
              <div className="pt-0 bg-white">
                <div className="grid grid-cols-3 font-bold text-center">
                  <button
                    className="text-base h-full w-full text-defaultPlayHuayDeactive bg-gradient-to-t from-[#D1B000] to-[#FFD700] px-5"
                    onClick={() => {
                      navigate("/historylottery");
                      dispatch(resetResultHuay());
                    }}
                  >
                    ดูโพยหวย
                  </button>
                  <div className="col-span-2">
                    <button
                      className="text-base h-full w-full text-[#f8eede] bg-gradient-to-t from-[#b3853e] to-[#b3853e] px-5 py-2 font-bold"
                      onClick={() => {
                        setOpen(false);
                        setIndex(0);
                        dispatch(resetResultHuay());
                      }}
                    >
                      กลับไปแทงอีกครั้ง
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <LoadingPage open={CloseButton}/>
      </Dialog>
    </React.Fragment>
  );
};

export default ModalGetBetCache;
